var _circle, _circle2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconActiveUserWeekly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#C5F5D3"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 11,
    r: 6,
    fill: "#26DC36"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.1667 28.436C34.2805 28.436 37.6154 25.1011 37.6154 20.9873C37.6154 16.8735 34.2805 13.5386 30.1667 13.5386C26.0529 13.5386 22.718 16.8735 22.718 20.9873C22.718 25.1011 26.0529 28.436 30.1667 28.436Z",
    fill: "#66D185"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1667 30.5642C26.4992 30.5687 22.9833 32.0276 20.39 34.6209C17.7968 37.2141 16.3379 40.7301 16.3334 44.3975C16.3334 44.6797 16.4455 44.9504 16.645 45.1499C16.8446 45.3495 17.1153 45.4616 17.3975 45.4616H42.9359C43.2181 45.4616 43.4887 45.3495 43.6883 45.1499C43.8878 44.9504 44 44.6797 44 44.3975C44 36.77 37.7941 30.5642 30.1667 30.5642Z",
    fill: "#66D185"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconActiveUserWeekly);
export default __webpack_public_path__ + "static/media/icon-active-user-weekly.3720e1d45750b5c095e4c786352225fa.svg";
export { ForwardRef as ReactComponent };